import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "title flex flex-row justify-between gap-2" }
const _hoisted_2 = { class: "build-name_cmd relative flex items-center font-gordita-medium gap-1 leading-none" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "uil uil-arrow-left absolute left-1 !text-[24px]" }, null, -1)
const _hoisted_4 = { style: {"max-width":"600px"} }
const _hoisted_5 = {
  key: 1,
  class: "gordita-400-13 text-Text/text_medium h-full content-center"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "rounded h-1 w-1 bg-Text/text_lowest" }, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "h-full flex col content-center gap-4 leading-none" }
const _hoisted_9 = {
  class: "cmd-tooltip",
  style: {"max-width":"600px"}
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "uil uil-copy place-self-center text-Text/text_low ml-[-10px] !text-[20px]" }, null, -1)
const _hoisted_11 = { class: "buttons flex" }

import { computed, ref } from 'vue';
import { IncrediButton, IncrediTooltip } from 'incredi-ui';

import { useCopyToClipboard } from '@/services/notify/copy-to-clipboard';
import IbxScopedCss from '@/components/IbxScopedCss/IbxScopedCss.vue';
import { Routes } from '@/router/router.const';
import { useWorkloadViewData } from '../workloads.helpers';
import TrimTextMiddle from '../components/trim-text-middle.vue';
import WorkloadViewHeaderInfo from './workload-view-header-info.vue';
import { useMinimizedHeader } from './minimized-header.helpers';


export default /*#__PURE__*/_defineComponent({
  __name: 'workload-view-header',
  setup(__props) {

const [minimized, setMinimized] = useMinimizedHeader();
const buildNameHover = ref(false);
const cmdHover = ref(false);
const buildNameRef = ref<HTMLDivElement | null>(null);

const shouldShowBuildNameTooltip = computed(() => (buildNameRef.value?.scrollWidth || 0) > (buildNameRef.value?.clientWidth || 0));

const res = useWorkloadViewData();
const workload = ref(res?.workload);

const copyCommandToClipboard = useCopyToClipboard();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(IbxScopedCss, { class: "w-full flex flex-col gap-4 no-shadow" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_unref(IncrediButton), {
            "data-testid": "back-button",
            size: "big",
            design: "ghost-neon",
            class: "relative h-full",
            style: {"border-radius":"50%","width":"32px","height":"32px"},
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: _unref(Routes).Builds })))
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }),
          (workload.value?.title)
            ? (_openBlock(), _createBlock(_unref(IncrediTooltip), {
                key: 0,
                "model-value": _unref(shouldShowBuildNameTooltip) && buildNameHover.value,
                class: "content-center",
                hover: "",
                direction: "top-sticky-left",
                delay: 200,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = (value) => (buildNameHover.value = value))
              }, {
                content: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, _toDisplayString(workload.value?.title), 1)
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    ref_key: "buildNameRef",
                    ref: buildNameRef,
                    "data-testid": "build-name",
                    class: "build-name text-[15px] leading-[normal] truncate rounded-sm max-w-[336px] h-[32px] p-1.5 text-Text/text_high hover:bg-Hovers/hover_grey"
                  }, _toDisplayString(workload.value?.title), 513)
                ]),
                _: 1
              }, 8, ["model-value"]))
            : _createCommentVNode("", true),
          (workload.value?.title)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
            : _createCommentVNode("", true),
          _createVNode(_unref(IncrediButton), {
            size: "small",
            design: "ghost-grey",
            class: "!px-0 h-full flex",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(copyCommandToClipboard)(workload.value?.commandLine)))
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_unref(IncrediTooltip), {
                  modelValue: cmdHover.value,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((cmdHover).value = $event)),
                  hover: "",
                  direction: "top-sticky-left",
                  delay: 200
                }, {
                  content: _withCtx(() => [
                    _createElementVNode("div", _hoisted_9, _toDisplayString(workload.value?.commandLine), 1)
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      class: _normalizeClass(["h-full items-center cmd text-text-high leading-normal py-1 px-1.5 truncate", {
                  'text-Text/text_medium': workload.value?.title,
                  'text-[13px]': workload.value?.title,
                  'text-[15px]': !workload.value?.title,
                  'font-gordita-medium': !workload.value?.title,
                  'max-w-[360px]': workload.value?.title,
                  'max-w-[710px]': !workload.value?.title,
                }]),
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(copyCommandToClipboard)(workload.value?.commandLine)))
                    }, [
                      _createVNode(TrimTextMiddle, {
                        text: workload.value?.commandLine || ''
                      }, null, 8, ["text"])
                    ], 2)
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _hoisted_10
              ])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_unref(IncrediButton), {
            class: "relative mr-2",
            "data-testid": "minmax-button",
            size: "small",
            design: "ghost-neon",
            style: {"border-radius":"50%","width":"32px","height":"32px"},
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_unref(setMinimized)(!_unref(minimized))))
          }, {
            default: _withCtx(() => [
              _createElementVNode("i", {
                class: _normalizeClass(["uil absolute left-[2px] !text-[20px]", [_unref(minimized) ? 'incredicon-maximize' : 'incredicon-minimize']])
              }, null, 2)
            ]),
            _: 1
          })
        ])
      ]),
      (!_unref(minimized))
        ? (_openBlock(), _createBlock(WorkloadViewHeaderInfo, {
            key: 0,
            status: workload.value?.buildResult!,
            "start-time": workload.value?.startTime!,
            duration: workload.value?.duration!,
            initiator: workload.value?.initiatorName!,
            "logged-on-users": workload.value?.loggedOnUsers!,
            project: workload.value?.title!,
            "build-type": workload.value?.buildType!
          }, null, 8, ["status", "start-time", "duration", "initiator", "logged-on-users", "project", "build-type"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})